<template>
  <div class="value-filter">
    <div class="city-parent">
      <div class="city">Mileage</div>
      <div class="buttons-wrapper">
        <div class="buttons7">
          <div class="div4">
            {{ Number(mileageSliderValue[0]) * 2000 }} -
            {{ Number(mileageSliderValue[1]) * 2000 }}
          </div>
          <div class="mpgmpge">{{ mPGMPGe }}</div>
        </div>
      </div>
    </div>
    <div class="range-selector">
      <div class="graph">
        <div
          v-for="index in 100"
          :key="index"
          :class="'graph-child-mileage graph-child-mileage' + index"
        ></div>
      </div>
      <div style="width: 100%">
        <vue-slider
          style="
            padding: 0px 0px;
            width: 100%;
            height: 4px;
            display: flex;
            justify-content: center;
          "
          v-model="mileageSliderValue"
          :dot-options="dotOptions"
          :order="false"
          :tooltip="'none'"
          :min="0"
          :max="100"
          @change="updateGraph"
          @drag-end="checkThumbPosition"
        >
          <template #dot="{ index }">
            <div v-if="index === 0 || index === 1" class="custom-slider-thumb">
              <img
                loading="lazy"
                alt=""
                src="../../assets/custom-slider-icon.svg"
              />
            </div>
          </template>
        </vue-slider>
        <div style="display: flex; justify-content: space-between">
          <span>0</span>
          <span>200K</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

const props = defineProps({
  mPGMPGe: String,
  min: String,
  max: String,
});

const emits = defineEmits(["mileageSliderValue"]);

const mileageSliderValue = ref([props.min, props.max]);
const dotOptions = [{ disabled: false, strokeWidth: 1 }, { disabled: false }];

const updateGraph = (value) => {
  const minValue = Math.round(value[0]);
  const maxValue = Math.round(value[1]);

  mileageSliderValue.value = [minValue, maxValue];
  if (props.min != minValue || props.max != maxValue) {
    emits("mileageSliderValue", mileageSliderValue);
  }

  // Resetting all graph colors to default gray
  const allGraphItems = document.querySelectorAll(".graph-child-mileage");
  allGraphItems.forEach((item) => {
    item.style.backgroundColor = "var(--gray-medium)";
  });

  // Marking graph items between min and max as blue
  for (let i = minValue; i <= maxValue; i++) {
    const graphChild = document.querySelector(`.graph-child-mileage${i}`);
    if (graphChild)
      graphChild.style.backgroundColor = "var(--primary-accent-base)";
  }
};
const checkThumbPosition = () => {
  // Check if min thumb crosses max thumb
  if (mileageSliderValue.value[0] > mileageSliderValue.value[1]) {
    // Adjust min thumb to be equal to max thumb
    mileageSliderValue.value[0] = mileageSliderValue.value[1] - 5;
    updateGraph(mileageSliderValue.value);
  }
};

onMounted(() => {
  updateGraph(mileageSliderValue.value);
});
</script>

<style scoped>
.custom-slider-thumb {
  position: relative;
  width: 14px;
  height: 14px;
  cursor: pointer;
  justify-content: center;
  display: flex;
}
.city {
  height: 23px;
  width: 80px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
  flex-shrink: 0;
  font-weight: 700;
}
.div4 {
  align-self: stretch;
  width: auto;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
  font-weight: 600;
  display: inline-block;
}
.mpgmpge {
  height: 21px;
  width: auto;
  position: relative;
  font-size: var(--paragraph-primary-medium-regular-size);
  line-height: 21px;
  display: flex;
  align-items: center;
}
.buttons7 {
  flex: 1;
  border-radius: var(--br-9xs);
  background-color: var(--white-light);
  border: 0.5px solid var(--primary-accent-base);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 15px;
  gap: var(--gap-4xs);
}
.buttons-wrapper {
  height: 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.city-parent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap-3xs);
}

.graph-child-mileage {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage1,
.graph-child-mileage26,
.graph-child-mileage51,
.graph-child-mileage76 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage2,
.graph-child-mileage27,
.graph-child-mileage52,
.graph-child-mileage77 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage3,
.graph-child-mileage28,
.graph-child-mileage53,
.graph-child-mileage78 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage4,
.graph-child-mileage29,
.graph-child-mileage54,
.graph-child-mileage79 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage5,
.graph-child-mileage30,
.graph-child-mileage55,
.graph-child-mileage80 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage6,
.graph-child-mileage31,
.graph-child-mileage56,
.graph-child-mileage81 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage7,
.graph-child-mileage32,
.graph-child-mileage57,
.graph-child-mileage82 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage8,
.graph-child-mileage33,
.graph-child-mileage58,
.graph-child-mileage83 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage9,
.graph-child-mileage34,
.graph-child-mileage59,
.graph-child-mileage84 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}
.graph-child-mileage10,
.graph-child-mileage35,
.graph-child-mileage60,
.graph-child-mileage85 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage11,
.graph-child-mileage36,
.graph-child-mileage61,
.graph-child-mileage86 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage12,
.graph-child-mileage37,
.graph-child-mileage62,
.graph-child-mileage87 {
  height: 21px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage13,
.graph-child-mileage38,
.graph-child-mileage63,
.graph-child-mileage88 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage14,
.graph-child-mileage39,
.graph-child-mileage64,
.graph-child-mileage89 {
  height: 30px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage15,
.graph-child-mileage40,
.graph-child-mileage65,
.graph-child-mileage90 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage16,
.graph-child-mileage41,
.graph-child-mileage66,
.graph-child-mileage91 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage17,
.graph-child-mileage42,
.graph-child-mileage67,
.graph-child-mileage92 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage18,
.graph-child-mileage43,
.graph-child-mileage68,
.graph-child-mileage93 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage19,
.graph-child-mileage44,
.graph-child-mileage69,
.graph-child-mileage94 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage20,
.graph-child-mileage45,
.graph-child-mileage70,
.graph-child-mileage95 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage21,
.graph-child-mileage46,
.graph-child-mileage71,
.graph-child-mileage96 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage22,
.graph-child-mileage47,
.graph-child-mileage72,
.graph-child-mileage97 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage23,
.graph-child-mileage48,
.graph-child-mileage73,
.graph-child-mileage98 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage24,
.graph-child-mileage49,
.graph-child-mileage74,
.graph-child-mileage99 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child-mileage25,
.graph-child-mileage50,
.graph-child-mileage75,
.graph-child-mileage100 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-11xs);
  width: 100%;
}
.range-selector {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-6xs);
  box-sizing: border-box;
  max-width: 100%;
  text-align: center;
}
.value-filter {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-21xl);
  flex-shrink: 0;
  max-width: 100%;
  text-align: left;
  font-size: var(--paragraph-secondary-large-semibold-size);
  color: var(--black-default);
  font-family: var(--paragraph-secondary-large-semibold);
  padding-bottom: 3rem;
}

</style>
